document.addEventListener("DOMContentLoaded", function () {
  const handle = window.ShopifyProductHandle;
  const key = "shopify-recently-viewed";

  if (!handle) return;

  let viewed = JSON.parse(localStorage.getItem(key)) || [];

  // Avoid duplicates and limit to last 10
  viewed = viewed.filter((h) => h !== handle);
  viewed.unshift(handle);
  if (viewed.length > 10) viewed = viewed.slice(0, 10);

  localStorage.setItem(key, JSON.stringify(viewed));
});
